import { useCfarStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

import { AirCfarExerciseGenericActionView } from "../AirCfarExerciseGenericActionView";

import defaultStyles from "./AirCfarExerciseErrorUnknown.module.scss";

export interface AirCfarExerciseErrorUnknownProps {
  onContactSupportClick: () => void;
  onGoBackClick: () => void;
}

export const AirCfarExerciseErrorUnknown = (
  props: AirCfarExerciseErrorUnknownProps
) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorUnknown,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseErrorUnknown
  );
  const { t } = useI18nContext();

  const { onContactSupportClick, onGoBackClick } = props;

  return (
    <div className={block}>
      <AirCfarExerciseGenericActionView
        title={t("core-flights-cfar.exercise.errorUnknown.title")}
        description={t("core-flights-cfar.exercise.errorUnknown.description")}
        footerButtons={[
          <button
            className={cn("contact-support-button")}
            onClick={onContactSupportClick}
          >
            {t("core-flights-cfar.exercise.errorUnknown.contactSupport")}
          </button>,
          <button className={cn("go-back-button")} onClick={onGoBackClick}>
            {t("core-flights-cfar.exercise.errorUnknown.goBack")}
          </button>,
        ]}
      />
    </div>
  );
};
